import HTML from './standard-preview.cmp.html';

export default {
  template: HTML,
  bindings: {
    bid: '<',
    token: '<'
  },
  controller: HotelRfpBidStandardPreviewController,
}

HotelRfpBidStandardPreviewController.$inject = [];
function HotelRfpBidStandardPreviewController(){
}
